export default __webpack_public_path__ + "static/media/PlayH1.999a2995.png";